import { render, staticRenderFns } from "./ManagePlugins.vue?vue&type=template&id=7a6a397c&"
import script from "./ManagePlugins.vue?vue&type=script&lang=js&"
export * from "./ManagePlugins.vue?vue&type=script&lang=js&"
import style0 from "./ManagePlugins.vue?vue&type=style&index=0&id=7a6a397c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports